// [Basis chrome] La navegacion de escritorio es la navbar de la landing.
//
// Este fichero elegia entre la navegacion horizontal de Blockscout y nada, segun
// NEXT_PUBLIC_NAVIGATION_LAYOUT. Ahora devuelve siempre la navbar de Basis, y el
// env se fija a `horizontal` (envs/frontend.env) para que el RESTO del layout
// -- SideBar, MainArea, MainColumn, CONTENT_MAX_WIDTH -- se acomode solo a una
// navegacion superior sin tocar ni una linea de esos ficheros. SideBar.tsx ya
// devuelve un componente vacio en ese modo.
import BasisNavBar from 'ui/snippets/basis/BasisNavBar';

export default BasisNavBar;
